const initialState = {
    fileName : null, 
    videoId : null, 
    thumbnailId : null,
    transcription : null,
    type: null,
    videoBlob: null
};

const uploadVid = (state = initialState, action) =>{
    switch(action.type){
        case "UPLOAD_VIDEO" : 
        return {
            ...state,
            ...{
                fileName : action.payload.fileName, 
                videoId : action.payload.videoId, 
                thumbnailId : action.payload.thumbnailId,
                transcription : action.payload.transcription,
                type : action.payload.type,
                videoBlob: action.payload.videoBlob
                
            },

        };

        case "RESET_UPLOAD_VIDEO" :
            return {
                ...state,
                ...{
                    fileName : null, 
                    videoId : null, 
                    thumbnailId : null,
                    transcription : null,
                    type : null,
                    videoBlob: null
            }
        }
        
        default: return state;

    }
}



export default uploadVid;